import { useEffect, useState } from "react"

const phone = 360;
const tablet = 768;
const desktop = 1024;

export const useLayout = () => {
  const [width, setWidth] = useState(1024);

  useEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  const handleResize = () => {
    setWidth(window.innerWidth)
  }

  return {
    // isAirMacBook: width >= desktop,
    isDesktop: width >= desktop,
    isTablet: width < desktop && width > tablet,
    isPhone: width < tablet,
  }
}
